import { z } from 'zod';
import { Validation } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export enum EditItemDialogFields {
    Reason = 'reason',
    Quantity = 'quantity',
    UnitPrice = 'unitPrice',
}

export const editItemSchema = z.object({
    [EditItemDialogFields.Reason]: Validation.String.Required.max(99),
    [EditItemDialogFields.Quantity]: z.number().int().min(1),
    [EditItemDialogFields.UnitPrice]: z
        .number()
        .refine((value) => value !== 0, { message: TextKey.ChargingZeroAmountErrorMessage }),
});

export type EditItemFormValues = z.infer<typeof editItemSchema>;
